/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

"use client";

import { I18NProvider, LocaleMessages } from "@epic-mw/i18n";

import { locales, fallbackLocale } from "@i18n/config";

interface Props {
	locale: string;
	children?: React.ReactNode;
	messages?: LocaleMessages;
}

export const Localization = ({ locale, children, messages }: Props): React.JSX.Element => {
	return (
		<I18NProvider locale={locale} locales={locales} messages={messages} defaultLocale={fallbackLocale}>
			{children}
		</I18NProvider>
	);
};
